/**
 * vue-i18n setup — delegates to webuikit's `createBroodI18n` SSOT
 * (5.16.4.1+). Replaces the 75-line hand-rolled detect / setLocale /
 * passport-sync that lived here.
 *
 * release-channel uses BCP-47 internal codes (`zh-CN` / `en-US`) and
 * defaults to `en-US` (existing UI is English; en-US is the primary
 * audience). Other settings use factory defaults.
 *
 * `app.use(i18nPlugin)` installs vue-i18n. `i18n` is exposed for direct
 * `i18n.global.locale` / `.t(...)` access.
 */
import { createBroodI18n } from '@brood/component-login'
import zhCN from '@/locales/zh-CN'
import enUS from '@/locales/en-US'

export type LocaleCode = 'zh-CN' | 'en-US'

const broodI18n = createBroodI18n({
  messages: { 'zh-CN': zhCN, 'en-US': enUS },
  supported: ['zh-CN', 'en-US'] as const,
  defaultLocale: 'en-US',
})

export const i18nPlugin = broodI18n
export const i18n = broodI18n.i18n
export const { setLocale, SUPPORTED_LOCALES, LOCALE_STORAGE_KEY } = broodI18n
